import { Tab, Tabs } from "./tabs";
export type { TabsProps, TabProps } from "./tabs";
import { attachPropertiesToComponent } from "../../utils/attachPropertiesToComponent";

export default attachPropertiesToComponent(Tabs, {
  Tab,
});
